// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","main":"errorMessage_main__2V4V0"};